/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationPrivacyShow } from '../../axios/organisationPrivacyShow'
import type {
	OrganisationPrivacyShowError,
	OrganisationPrivacyShowPathParams,
	OrganisationPrivacyShowResponse,
} from '../../types/OrganisationPrivacyShow'

export const organisationPrivacyShowQueryKey = (organisation: OrganisationPrivacyShowPathParams['organisation']) =>
	[{ url: '/organisations/:organisation/privacy', params: { organisation } }] as const

export type OrganisationPrivacyShowQueryKey = ReturnType<typeof organisationPrivacyShowQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPrivacyController.php OrganisationPrivacyController::show */
export function organisationPrivacyShowQueryOptions(
	organisation: OrganisationPrivacyShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationPrivacyShowResponse,
		AxiosError<OrganisationPrivacyShowError>,
		OrganisationPrivacyShowResponse,
		OrganisationPrivacyShowQueryKey
	>({
		queryKey: organisationPrivacyShowQueryKey(organisation),
		queryFn: ({ signal }) => organisationPrivacyShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPrivacyController.php OrganisationPrivacyController::show */
export function useOrganisationPrivacyShow<TSelectData = OrganisationPrivacyShowResponse>(
	organisation: OrganisationPrivacyShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationPrivacyShowResponse,
					AxiosError<OrganisationPrivacyShowError>,
					TSelectData,
					OrganisationPrivacyShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationPrivacyShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationPrivacyShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPrivacyController.php OrganisationPrivacyController::show */
export function useOrganisationPrivacyShowSuspense<TSelectData = OrganisationPrivacyShowResponse>(
	organisation: OrganisationPrivacyShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationPrivacyShowResponse,
					AxiosError<OrganisationPrivacyShowError>,
					TSelectData,
					OrganisationPrivacyShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationPrivacyShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationPrivacyShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
